import { useQuery } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import { certificatesApi } from '../../api/client'
import { BookOpen, Award, TrendingUp } from 'lucide-react'
import { useAuthStore } from '../../store/authStore'

export default function DashboardPage() {
  const { user } = useAuthStore()

  const { data: certs } = useQuery({
    queryKey: ['my-certs'],
    queryFn: () => certificatesApi.myCertificates().then(r => r.data),
  })

  return (
    <div className="max-w-5xl mx-auto px-4 py-10">
      <div className="mb-8">
        <h1 className="text-3xl font-extrabold mb-1">
          Welcome back, {user?.full_name?.split(' ')[0] || user?.username}! 👋
        </h1>
        <p className="text-brand-muted">Track your learning progress and certificates</p>
      </div>

      <div className="grid md:grid-cols-3 gap-5 mb-10">
        <StatCard icon={<BookOpen size={22} className="text-brand-blue"/>} label="Enrolled courses" value="—" />
        <StatCard icon={<TrendingUp size={22} className="text-brand-green"/>} label="Lessons completed" value="—" />
        <StatCard icon={<Award size={22} className="text-amber-400"/>} label="Certificates earned" value={certs?.length ?? 0} />
      </div>

      <div className="mb-8">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-bold">Recent Certificates</h2>
          <Link to="/certificates" className="text-sm text-brand-blue">View all →</Link>
        </div>
        {certs && certs.length > 0 ? (
          <div className="grid sm:grid-cols-2 gap-4">
            {certs.slice(0, 4).map(c => (
              <div key={c.id} className="card flex items-start gap-3">
                <Award size={20} className="text-amber-400 mt-0.5 flex-shrink-0"/>
                <div>
                  <p className="font-semibold text-sm">{c.course_title}</p>
                  <p className="text-xs text-brand-muted">{new Date(c.issued_at).toLocaleDateString()}</p>
                  <Link to="/certificates" className="text-xs text-brand-blue mt-1 inline-block">Download PDF →</Link>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="card text-center py-10 text-brand-muted">
            <Award size={36} className="mx-auto mb-3 opacity-30"/>
            <p>No certificates yet. Complete a course to earn one!</p>
            <Link to="/learn" className="btn-primary mt-4 inline-flex">Browse Courses</Link>
          </div>
        )}
      </div>
    </div>
  )
}

function StatCard({ icon, label, value }: { icon: React.ReactNode; label: string; value: string | number }) {
  return (
    <div className="card flex items-center gap-4">
      <div className="p-3 rounded-lg bg-brand-surface2">{icon}</div>
      <div>
        <p className="text-2xl font-extrabold">{value}</p>
        <p className="text-sm text-brand-muted">{label}</p>
      </div>
    </div>
  )
}
